import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Hidden from  '@material-ui/core/Hidden';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar'
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {Step3} from './Step3';
import {Step1} from './Step1';
import {Step2} from './Step2';
import {Submission} from './Submission';


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width:1000,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

function getSteps() {
  return ['DATOS PERSONALES', 'DATOS SOBRE LA TITULACIÓN','DOCUMENTOS'];
}


function getStepContent(stepIndex, setActiveStep, data, setData) {
  switch (stepIndex) {
    case 0:
      return <div> <Step3 submit={setActiveStep} setData = {setData} data={data}/>  </div>
    case 1:
      return <div> <Step2 submit={setActiveStep} setData = {setData} data={data}/>  </div>
    case 2:
      return <div> <Step1 submit={setActiveStep} setData = {setData} data={data}/>  </div>
    case 3:
      return <div> <Submission submit={setActiveStep} data={data}/>  </div>
    default:
      return 'Unknown stepIndex';
  }
}

export default function StepComponent() {
  
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);

  const steps = getSteps();
  const [data, setData] = React.useState({})
  //console.log(data)
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  return (
    
    <React.Fragment>
      <CssBaseline />
      <AppBar position="absolute" color="default" className={classes.appBar}>       
      </AppBar>
      <main className={classes.layout}>
      <Paper className={classes.paper}>  
      <Typography component="h1" variant="h4" align="center">
          Homologación de títulos de maestrías y de especialidades de posgrado obtenidos en el extranjero
          </Typography>   
      <Hidden mdDown>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      </Hidden> 
      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography className={classes.instructions}>Trámite insertado satisfactoriamente. Se le enviará un correo electrónico cuando su trámite cambie de estado. Muchas Gracias</Typography>           
          </div>
        ) : (
          <div>
            <Typography className={classes.instructions}>
              {getStepContent(activeStep, setActiveStep, data, setData)}
              </Typography>
          </div>
        )}      
     </div>
      </Paper>  
      </main>          
    </React.Fragment>    
  );
}
